import { Icon } from '@iwoca/orion';
import clsx from 'clsx';
import styles from './InformationMessage.module.css';

type TProps = {
  alignCenter?: boolean;
  message: string;
  className?: string;
};

export const InformationMessage = ({
  alignCenter,
  message,
  className,
}: TProps) => {
  return (
    <div
      className={clsx(styles.informationMessageContainer, className, {
        [styles.alignCenter]: alignCenter,
      })}
      data-testid="information-message"
    >
      <Icon height={20} width={20} icon="infoCircleFilled" />
      <p className={styles.infoText}>{message}</p>
    </div>
  );
};
